export const setHandbookPassword = (key: string, password: string) =>
  localStorage.setItem(`folderPassword-${key}`, password)
export const getHandbookPassword = (key?: string) => localStorage.getItem(`folderPassword-${key}`) || ''
